import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetDecisionFields as GetDecisionFieldsQuery,
    GetDecisionFieldsVariables as GetDecisionFieldsVariables,
    GetDecisionFields_form_editableVersion_fields as Field,
    GetDecisionFields_form_editableVersion_fields_attribute as Attribute,
} from 'nutshell-graphql-types';

import GET_DECISION_FIELDS from '../queries/get-decision-fields.graphql';

export type EntityType = 'lead';

export type DecisionField = Field & {
    attribute: Attribute;
};

export const useGetDecisionFields = (
    formId: string,
    entityType?: EntityType
): {
    fields: DecisionField[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetDecisionFieldsQuery,
        GetDecisionFieldsVariables
    >(GET_DECISION_FIELDS, {
        variables: {
            formId,
        },
    });

    const {form} = data ? data : {};

    // @ts-expect-error
    const fields: DecisionField[] = form
        ? form.editableVersion.fields
              // Only get decision/enum fields
              .filter((field) => field.attribute && field.attribute.type === 'ENUM')
              .filter((field) => {
                  if (entityType === 'lead') {
                      return field.entityName && field.entityName === 'LEAD';
                  }

                  return true;
              })
        : [];

    return {
        fields,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
